<template>
  <n-space>
    <n-switch
      style="margin-left: 25px"
      :rail-style="railStyle"
      v-model:value="$store.state.screenModeActive"
      @update:value="handleChange"
      size="large"
    >
      <template #checked-icon><i class="fa-thin fa-moon"></i></template>
      <template #unchecked-icon
        ><i class="fa-thin fa-brightness-low"></i
      ></template>
    </n-switch>
  </n-space>
</template>

<script>
import { useStore } from "vuex";
import { NSpace, NSwitch } from "naive-ui";
import { ref } from "vue";
export default {
  name: "DarkLightModeSwitch",
  components: { NSpace, NSwitch },
  data() {
    return {
      active: ref(false),
    };
  },
  setup() {
    const store = useStore();
    return {
      handleChange(value) {
        let app = document.getElementById("app");

        if (value) {
          document.body.style.background = "#131313";
          app.style.background = "#131313";
          store.commit("setScreenMode", "dark");
          localStorage.setItem("ScreenMode", "dark");
          store.dispatch("setScreenModeForUserInStrapi", "dark");
        } else {
          document.body.style.background = "white";
          app.style.background = "white";
          store.commit("setScreenMode", undefined);
          localStorage.setItem("ScreenMode", "light");
          store.dispatch("setScreenModeForUserInStrapi", "light");
        }
      },
      railStyle: ({ focused, checked }) => {
        const style = {};
        if (checked) {
          style.background = "transparent";
          style.border = "#C0C0C0";
          if (focused) {
            style.boxShadow = "0 0 0 2px #d0305040";
          }
        } else {
          style.background = "transparent";
          if (focused) {
            style.boxShadow = "0 0 0 2px #2080f040";
          }
        }
        return style;
      },
    };
  },
  mounted() {
    if (this.$store.state.isLoggedIn) {
      if (this.$store.state.screenMode === "dark") {
        let app = document.getElementById("app");
        app.style.background = "#131313";
        document.body.style.background = "#131313";
        this.$store.commit("setScreenMode", "dark");
        this.$store.state.screenModeActive = true;
      } else {
        document.body.style.background = "white";
        app.style.background = "white";
        this.$store.commit("setScreenMode", undefined);
        localStorage.setItem("ScreenMode", "light");
        this.$store.dispatch("setScreenModeForUserInStrapi", "light");
        this.$store.state.screenModeActive = false;
      }
    } else if (localStorage.getItem("ScreenMode") === "dark") {
      let app = document.getElementById("app");
      app.style.background = "#131313";
      document.body.style.background = "#131313";
      this.$store.commit("setScreenMode", "dark");
      this.$store.state.screenModeActive = true;
    } else {
      document.body.style.background = "white";
      app.style.background = "white";
      this.$store.commit("setScreenMode", undefined);
      localStorage.setItem("ScreenMode", "light");
      this.$store.dispatch("setScreenModeForUserInStrapi", "light");
      this.$store.state.screenModeActive = false;
    }
  },
};
</script>

<style>
.n-switch__button {
  background: var(--yungo-primary-button) !important;
}

.n-switch__rail {
  border: 1px solid #c0c0c0 !important;
  height: 27px !important;
}

.n-switch__button-icon i {
  color: white !important;
}

@media only screen and (max-width: 1180px) {
  .n-switch {
    margin: 0 !important;
  }
}
</style>